import eventBus from '../events/eventBus';

class Loading {
    public start(message: string) {
        eventBus.emit('loading-start', message);
    }

    public update(message: string, percentage: number) {
        eventBus.emit('loading-update', { message, percentage });
    }

    public end() {
        eventBus.emit('loading-end');
    }
}

const loading = new Loading();

export default loading;
